// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#primary-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
  gap: var(--spacer2);
}
#primary-nav ul li {
  font-size: 0.875rem;
}
#primary-nav ul li a {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacer2);
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  padding: var(--spacer4) var(--spacer2);
  transition: var(--fx1);
  border-bottom: 3px solid transparent;
}
#primary-nav ul li a:hover {
  background-color: var(--gray-100);
  border-bottom: 3px solid var(--gray-200);
  color: var(--primary);
}
#primary-nav ul li.is-active a {
  color: var(--primary);
  border-bottom: 3px solid var(--primary);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
